export default __webpack_public_path__ + "static/media/logo-dark.79fc3bb8.svg";